import parallax from './parallax';
import introItems from './intro';
import recomendation from './recomendation';
import helpers from '../helpers';

export const def = {
	name: 'default',
	leave(data) {
		return new Promise((resolve) => {
			gsap.timeline({
				onComplete() {
					resolve();
				},
			})
				.to(data.current.container, {
					autoAlpha: 0,
					duration: 0.4,
				});
		});
	},
	once(data) {
		gsap.timeline({
			onStart() {
				$('.site').removeClass('is-hidden');
			},
		})
			.to('.loader', {
				autoAlpha: 0,
			})
			.from(data.next.container, {
				autoAlpha: 0,
				clearProps: 'all',
			}, '-=0.3');
	},
	enter({
		next,
	}) {
		gsap.timeline({
			onStart() {
				$('.site').removeClass('is-hidden');
			},
			onComplete() {
				$('.footer').show();
			},
		})
			.from(next.container, {
				autoAlpha: 0,
				duration: 0.3,
				clearProps: 'all',
			});
	},
};

export const intro = (getCookie = false, full = true) => {
	if (!helpers.isMobile() || innerWidth > innerHeight) {
		getCookie = false;
	}

	return new Promise((resolve) => {
		const tl = gsap.timeline({
			onStart() {
				introItems.init();
			},
			onComplete() {
				parallax.init(document.querySelector('.intro'));
				// introItems.init();

				setTimeout(() => {
					parallax.enable();
				}, 100);

				resolve();
			},
		});

		if (getCookie) {
			tl.delay(0.5)
				.from('.intro__picture', {
					y: (index, target) => {
						return $(target).innerHeight();
					},
					autoAlpha: 0,
					ease: 'back.out(2)',
					stagger: {
						amount: 1,
						from: 'end',
					},
				})
				.add(() => {
					recomendation.init();
				});
		} else {
			$('.intro__content').add('.intro__items').removeClass('is-hidden');

			if (full) {
				tl.delay(0.5)
					.from('.intro__picture', {
						y: (index, target) => {
							return $(target).innerHeight();
						},
						autoAlpha: 0,
						ease: 'back.out(2)',
						stagger: {
							amount: 1,
							from: 'end',
						},
					});
			}

			tl.from(['.intro__pretext', '.intro__title', '.intro__text', '.intro__share', '.intro__links'], {
				y: 100,
				autoAlpha: 0,
				stagger: 0.2,
				clearProps: 'all',
				ease: 'back.out(2)',
			})
				.addLabel('start')
				.from('.intro__item-picture', {
					y: 200,
					autoAlpha: 0,
					stagger: 0.2,
					clearProps: 'all',
					ease: 'back.out(3)',
					onStart() {
						$('.intro__item-picture').css({
							transition: 'none',
						});
					},
				})
				.from('.intro__item-bg--front', {
					y: 300,
					autoAlpha: 0,
					clearProps: 'all',
					ease: 'back.out(3)',
					stagger: 0.2,
				}, 'start+=0.2')
				.from('.intro__item-bg--back', {
					y: 300,
					autoAlpha: 0,
					clearProps: 'all',
					ease: 'back.out(3)',
					stagger: 0.2,
				}, 'start+=0.2')

				.from('.intro__item-btn-container', {
					y: 80,
					autoAlpha: 0,
					stagger: 0.2,
					clearProps: 'all',
					ease: 'back.out(3)',
				}, '-=0.75');
		}
	});
};
